import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: any) => ({
  inputRoot: {
    color: theme.palette.colors.menuFont,
    fontFamily: 'Roboto',
    fontSize: '13px',
    margin: 'auto',
    width: '300px',
    display: 'flex',
    flexDirection: 'row',
    height: '36px',
    borderRadius: '4px',
    padding: '0 15px',
    backgroundColor: theme.palette.colors.mainSearchBackground,
    maxWidth: '70%'
  },
  closeIconStyle: {
    color: 'white',
    padding: '7px',
    '& svg': {
      fontSize: '24px'
    }
  },
  view: {
    display: 'flex',
    height: '100%'
  },
  contentArea: {
    width: '100%',
    height: '100vh',
    maxWidth: 'calc(100% - 240px)',
    overflow: 'hidden'
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '0 1rem',
    height: '70px',
    background: theme.palette.background.default
  },
  shareButton: {
    minHeight: '40px',
    maxHeight: '40px',
    minWidth: '169px',
    fontSize: '16px',
    fontWeight: 'normal',
    lineHeight: 'normal',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '6px',
    background: theme.gradiants.button,
    '&:hover': {
      boxShadow: 'none'
    },
    '&:focus': {
      boxShadow: 'none'
    }
  },
  loadingContainer: {
    height: 70,
    background: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10
  },
  wrapper: {
    height: 'calc(100vh - 130px)',
    padding: '0 1rem 1rem',
    background: 'rgb(236, 235, 239)',
    flexFlow: 'row nowrap'
  },
  tableWrapper: {
    height: '100%',
    "& [class*='pagination'], & [class*='rowsPerPage'], & [class*='rows-per-page'], & [class*='select-display-val']": {
      fontSize: "13px !important"
    }
  },
  popUpContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  tooltipContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '5px 0'
  },
  cellContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  iconButton: {
    fontSize: "1rem"
  },
  questionMark: {
    color: "#aaa2aa",
    fontSize: "1rem",
  }
}));

export default useStyles;
